module.exports = __webpack_public_path__ + "img/previous.95911f67.svg";